import React, {Component} from "react";
import ReportView from "./ReportView";
import DashboardTaskTraining from "../dashboard/DashboardTaskTraining";
import './ReportViewSplit.scss'
import classNames from "classnames";
import CustomForm from "../../../shared/components/form/CustomForm";
import Modal from "../../../shared/ui/Modal";
import trainingPhasesActionCreators from "../../store/training-phases/action-creators";
import trainingPhasesActions from "../../store/training-phases/action-creators";
import {connect} from "react-redux";
import dashboardActionCreators from "../../store/dashboard/action-creators";
import oitsActionCreators from "../../store/oits/action-creators";
import ScheduledReportAdd from "./ScheduledReportAdd";
import trainingPhaseSelectors from "../../store/training-phases/selectors";
import ReportDictation from "./dynamic-form/ReportDictation";
import notificationsActionsCreator from "../../store/notifications/action-creators";

class ScheduledReportAddSplit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showChangeReportPhaseDialog: false,
      currentChangePhaseReportGuid: null,
      currentChangePhase: null,
      tasksOpened: false,
      dictationOpened: false,
      currentReport: null,
      dictation: null,
      overrideResponses: false
    }
  }

  get oit() {
    return this.props.oits.find(o => o.guid === this.props.report.oitGuid)
  }

  get changePhaseConfig() {
    return {
      fields: {
        phase: {
          type: 'select',
          label: 'Phase',
          value: 'value',
          optionLabel: 'label',
          options: this.oit.trainingPhases.map(tp => ({
            value: tp.trainingPhaseGuid,
            label: tp.header
          }))
        },
        datetime: {
          type: 'date',
          label: 'Report date (optional)'
        }
      }
    }
  }

  updateReportPhase(data) {
    this.props.updateReport({...data, datetime: data.datetime, guid: this.state.currentChangePhaseReportGuid})
      .then(() => this.props.viewTrainingPhase(data.phase))
      .then(() => {
        this.setState({
          showChangeReportPhaseDialog: false
        })
      })

  }
  openTasks(report) {
    this.props.onSplitScreen && this.props.onSplitScreen(true)
    this.setState({
      tasksOpened: true,
      dictationOpened: false
    })
  }

  openDictation(report) {
    this.props.onSplitScreen && this.props.onSplitScreen(true)
    this.setState({
      tasksOpened: false,
      dictationOpened: true,
      currentReport: report
    })
  }

  async onChangePhase(report) {
    if(!this.props.oits) {
      await this.props.loadOitsContainer()
    }
    this.setState({
      showChangeReportPhaseDialog: true,
      currentChangePhaseReportGuid: report.guid,
      currentChangePhase: {
        phase: report.trainingPhaseGuid,
        datetime: report.responses[0] && report.responses[0].datetime ? (report.responses[0].datetime.split('T')[0]) : null
      }
    })
  }

  onReportResponse(response) {
    this.setState({
      overrideResponses: true
    }, () => {
      let report = this.props.report;
      let responses = report.responses;
      for(let i = 0; i < response.length; i++) {
        let r = response[i];
        if(!r) {
          continue;
        }
        let index = responses.findIndex(res => parseInt(r.sequence) === parseInt(res.sequence))
        responses[index] = r;
      }

      const formData = {
        guid: report.guid,
        responses: responses,
        signedAt: report.signedAt,
        shift: report.shift
      };

      this.props.updateReportResponses(formData, true)
        .then(() => {
          this.setState({
            dictationOpened: false,
          })
          this.props.onSplitScreen && this.props.onSplitScreen(false)
          setTimeout(() => {
            this.setState({
              overrideResponses: false
            })
          }, 400)
        })
        .catch(ex => {
          console.log('ERRROR', ex)
        })

    })

  }

  render() {
    return (
      this.props.report ? <div className={classNames("modal-split-content")}>
        <div className="main-modal-content">
          <ScheduledReportAdd
            overrideResponses={this.state.overrideResponses}
            onOpenTasks={(report) => this.openTasks(report)}
            onOpenDictation={(report) => this.openDictation(report)}
            onChangePhase={(report) => this.onChangePhase(report)}
            onUpdateReport={(report) => this.setState({currentReport: report})}
          />
        </div>
        {this.props.isSplitScreen && this.state.tasksOpened &&
          <div className="side-modal-content">
            <DashboardTaskTraining oitGuid={this.props.report.oitGuid} />
          </div>
        }

        {this.props.isSplitScreen && this.state.dictationOpened &&
          <div className="side-modal-content">
            <ReportDictation
              report={this.props.report}
              dictation={this.state.dictation}
              onResponse={(response) => this.onReportResponse(response)}
              onChange={(dictation) => this.setState({dictation})}
              onClose={() => this.props.onSplitScreen(false)}
            />
          </div>
        }

        <Modal
          isOpen={this.state.showChangeReportPhaseDialog}
          onClose={() => this.setState({
            showChangeReportPhaseDialog: false
          })}
          fullscreen={true}
          title="Change phase">
          {this.state.showChangeReportPhaseDialog && (
            <CustomForm
              config={this.changePhaseConfig}
              initialValues={this.state.currentChangePhase}
              onSubmit={(data) => this.updateReportPhase(data)}
            />
          )}
        </Modal>
      </div>: <div></div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    oits: state.oits.list,
    report: trainingPhaseSelectors.addingScheduledReport(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateReport: (formData) => {
      return dispatch(trainingPhasesActionCreators.updateReport(formData));
    },
    viewTrainingPhase: (phaseGuid) => {
      return dispatch(trainingPhasesActions.viewTrainingPhase(phaseGuid));
    },
    loadOitsContainer: (scope, status) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope, status));
    },
    updateReportResponses: (formData, isAutoSave) => {
      return dispatch(trainingPhasesActionCreators.updateReportResponses(formData, isAutoSave));
    },
    notifyError: (message) =>
      dispatch(notificationsActionsCreator.addError(message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledReportAddSplit)
